import React from 'react';
import { FileText, Images, Microscope, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface ImportEmptyFallbackProps {
  contentType: 'images' | 'research' | 'pages';
  searchQuery: string;
}

export const ImportEmptyFallback: React.FC<ImportEmptyFallbackProps> = ({
  contentType,
  searchQuery
}) => {
  const navigate = useNavigate();

  const getConfig = () => {
    switch (contentType) {
      case 'pages':
        return {
          icon: FileText,
          route: '/private-text-generator',
          buttonText: 'Create New Document',
          buttonClasses: 'bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white'
        };
      case 'research':
        return {
          icon: Microscope,
          route: '/private-research-generator',
          buttonText: 'Create New Research',
          buttonClasses: 'bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white'
        };
      case 'images':
      default:
        return {
          icon: Images,
          route: '/private-image-generator',
          buttonText: 'Create New Image',
          buttonClasses: 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white'
        };
    }
  };

  const config = getConfig();
  const IconComponent = config.icon;

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <IconComponent size={48} className="text-gray-300 mb-4" />
      <h3 className="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">
        {searchQuery ? `No ${contentType} found` : `No ${contentType} available`}
      </h3>
      {!searchQuery && (
        <div className="space-y-4 max-w-md">
          <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
            Create {contentType} first to add to your project.
          </p>
          <Button 
            onClick={() => navigate(config.route)}
            className={`${config.buttonClasses} font-semibold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105`}
            size="lg"
          >
            <Plus className="w-5 h-5 mr-2" />
            {config.buttonText}
          </Button>
        </div>
      )}
    </div>
  );
}; 